import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import VueGtag from "vue-gtag";
import VueI18n from 'vue-i18n'
import {messages} from './translations.js'

Vue.config.productionTip = false
Vue.use(Chartkick.use(Chart))

Vue.use(VueGtag, {
  config: { id: "UA-179874933-1" }
});

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: navigator.language.split('-')[0],
  fallbackLocale: 'en',
  messages,
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')


